import { ChevronDown } from "react-feather";
import styles from "../communication-chat.module.css";
import { useEffect, useState } from "react";
import moment from "moment";

const ProspectListunread = (props) => {
  const [prospectUnreadMessages, SetProspectUnreadMessages] = useState([]);
  const [unreadMessageCounter, setUnreadMessageCounter] = useState(0);

  useEffect(() => {
    const prospects = props.unreadMessageList
      .filter((p) => p.type === "Prospect" && p.message)
      .sort((a, b) => {
        const unreadA = a.unread_no > 0 ? 1 : 0;
        const unreadB = b.unread_no > 0 ? 1 : 0;

        // Prioritize unread messages first
        if (unreadA !== unreadB) {
          return unreadB - unreadA; // Unread messages come first
        }

        // If both are in the same group (both read or both unread), sort by message_time
        const timeA = a.message_time ? new Date(a.message_time).getTime() : 0;
        const timeB = b.message_time ? new Date(b.message_time).getTime() : 0;

        return timeB - timeA; // Latest message first
      });

    SetProspectUnreadMessages(prospects);

    const totalUnread = prospects.reduce((acc, message) => {
      return acc + message.unread_no;
    }, 0);

    setUnreadMessageCounter(totalUnread);
  }, [props]);

  // Function to format phone number
  const formatPhoneNumber = (phoneNumber) => {
    const cleaned = ("" + phoneNumber).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return cleaned;
  };

  return (
    <>
      <div
        onClick={() => props.toggleAccordionForProspectUnRead()}
        className={
          props.accordionOnForProspectUnRead
            ? `${styles.accordionOn} ${styles.Open}`
            : `${styles.accordionOn}`
        }
      >
        <p className={`${styles.ListAccoudionTitle}`}>
          <ChevronDown /> Prospects <span>{unreadMessageCounter}</span>
        </p>
        {prospectUnreadMessages.length > 0 &&
          prospectUnreadMessages.map((prospect, i) => {
            return (
              <div key={i}>
                <div
                  className={
                    prospect.id === props?.prospectTenantDetails?.id
                      ? `${styles.activeTenant} ${styles.CommuListSec}`
                      : `${styles.CommuListSec}`
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    props.setDetails(prospect);
                  }}
                >
                  <div className={`${styles.CommuListDeSec}`}>
                    <p className={`${styles.ProsTenantList}`}>
                      {prospect?.first_name && (
                        <span>
                          {prospect?.first_name}&nbsp;{prospect?.last_name}
                        </span>
                      )}
                      {!prospect?.first_name && (
                        <span>{formatPhoneNumber(prospect?.phone)}</span>
                      )}
                      {/* { prospect?.current_status === 0 &&  <span
                        className={`${styles.StatusBadge} ${styles.NotApplied}`}
                      >
                        Not Applied
                      </span> }
                      { prospect?.current_status === 1 && <span
                        className={`${styles.StatusBadge} ${styles.Applied}`}
                      >
                        Applied
                      </span> }
                      { prospect?.current_status === 2 && <span
                        className={`${styles.StatusBadge} ${styles.Screened}`}
                      >
                        Screened
                      </span> }
                      { prospect?.current_status === 3 && <span
                        className={`${styles.StatusBadge} ${styles.Approved}`}
                      >
                        Approved
                      </span> }
                      { prospect?.current_status === 4 && <span
                        className={`${styles.StatusBadge} ${styles.Declined}`}
                      >
                        Declined
                      </span> } */}
                      {/* <span
                        className={`${styles.StatusBadge} ${styles.Applied}`}
                      >
                        Applied
                      </span> */}
                      {/* <span
                        className={`${styles.StatusBadge} ${styles.Screened}`}
                      >
                        Screened
                      </span> */}
                      {/* <span
                        className={`${styles.StatusBadge} ${styles.Approved}`}
                      >
                        Approved
                      </span> */}
                      {/* <span
                        className={`${styles.StatusBadge} ${styles.Declined}`}
                      >
                        Declined
                      </span> */}
                    </p>
                    {/* <p className={`${styles.ProsTenantListDe}`}>
                      <span>{prospect?.property_name}</span>
                      {prospect?.current_status !== 0 &&<span>{prospect?.apt_no}</span>}
                    </p> */}
                  </div>
                  {prospect?.message && (
                    <div className={`${styles.CommuListStatusSec}`}>
                      <p className={`${styles.UnreadMessageTime}`}>
                        {moment(prospect?.message_time).fromNow()}
                      </p>
                    </div>
                  )}
                  {prospect?.message && (
                    <div className={`${styles.UnreadMsgSec}`}>
                      <p
                        className={
                          prospect?.unread_no > 0 &&
                          !prospect?.message.startsWith("You:")
                            ? `${styles.UnreadMessage} ${styles.Unread}`
                            : `${styles.UnreadMessage}`
                        }
                      >
                        {prospect?.message}
                      </p>
                    </div>
                  )}
                  {prospect?.unread_no > 0 && (
                    <div className={`${styles.UnreadMsgCountSec}`}>
                      <span className={`${styles.PropertyGroupNotiCount}`}>
                        {prospect?.unread_no}
                      </span>
                    </div>
                  )}
                  {!prospect?.message && (
                    <div className={`${styles.UnreadMsgSec}`}>
                      <p className={`${styles.CommounMsg}`}>--</p>
                    </div>
                  )}
                  {/* {prospect?.message && <div>
                  <div>{prospect?.message}</div>
                  <div>{moment(prospect?.message_time).fromNow()}</div>
                  </div>} */}
                </div>

                {/* <p
                  className={
                    prospect.id === props?.prospectTenantDetails?.id
                      ? `${styles.activeTenant} ${styles.ProsTenantList}`
                      : `${styles.ProsTenantList}`
                  }
                >
                  {prospect?.first_name && (
                    <span className={`${styles.Name}`}>
                      {prospect?.first_name}&nbsp;{prospect?.last_name}
                    </span>
                  )}{" "}
                  <span className={`${styles.Phone}`}>
                    {formatPhoneNumber(prospect?.phone)}
                  </span>
                </p> */}
              </div>
            );
          })}
        {prospectUnreadMessages.length === 0 && (
          <div className={`${styles.NoDataSecOnlyText}`}>
            <img src="/static/img/chatIcon.png" alt="" />
            <p>No prospect here!</p>
          </div>
        )}
      </div>
    </>
  );
};

export default ProspectListunread;
